/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { FilterOperator } from './filterOperator.schema';

export const FilterDescriptor = zod.object({
  "field": zod.string(),
  "operator": zod.lazy(() => FilterOperator),
  "value": zod.unknown().optional()
});

export type FilterDescriptor = zod.input<typeof FilterDescriptor>;
export type FilterDescriptorOutput = zod.output<typeof FilterDescriptor>;
